import React from 'react'
import './Avatar.css'

const AvatarUI = ({avatarUrl, userName, userLeft}) =>
  <React.Fragment>
    {
      !userLeft &&
      <img className='g_avatar' src={avatarUrl} alt='' data-tip={userName} />
    }
    {
      userLeft &&
      <div className='icon icon-user g_avatar' data-tip={userName} />
    }
  </React.Fragment>

export default AvatarUI
